import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SLOTS, nextWeekday, prettyDate, toISODate } from "@/lib/studio";
import { api } from "@/lib/api";

const SlotStatus = ({ slots, free }) => {
  if (slots === null) return <span className="font-tech text-xs text-zinc-600">…</span>;
  if (free) return <span className="font-tech text-xs uppercase tracking-widest text-emerald-400">Open</span>;
  return <span className="font-tech text-xs uppercase tracking-widest text-zinc-600 line-through">Booked</span>;
};

export const NextOpenDay = () => {
  const [iso, setIso] = useState(null);
  const [slots, setSlots] = useState(null);

  useEffect(() => {
    api.get("/closures")
      .then((r) => new Set(r.data.map((c) => c.date)))
      .catch(() => new Set())
      .then((closed) => setIso(toISODate(nextWeekday(undefined, closed))));
  }, []);

  useEffect(() => {
    if (!iso) return;
    api.get("/availability", { params: { date: iso } }).then((r) => setSlots(r.data.slots)).catch(() => setSlots([]));
  }, [iso]);

  const isFree = (id) => slots?.find((s) => s.id === id)?.available;

  return (
    <div className="surface bg-[#121216]/80 p-8 backdrop-blur-xl" data-testid="hero-next-open-day">
      <div className="flex items-center justify-between">
        <p className="font-tech text-xs uppercase tracking-[0.2em] text-zinc-400">Next open day</p>
        <span className="flex items-center gap-2 font-tech text-[10px] uppercase tracking-[0.2em] text-[#00F0FF]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" /> Live
        </span>
      </div>
      <p className="mt-3 font-display text-2xl font-semibold uppercase text-white" data-testid="hero-next-date">{iso ? prettyDate(iso) : "…"}</p>
      <ul className="mt-6 space-y-3">
        {SLOTS.map((s) => (
          <li key={s.id} className="flex items-center justify-between border-t border-white/5 pt-3" data-testid={`hero-slot-${s.id}`}>
            <span className="font-tech text-sm text-zinc-200">{s.time}</span>
            <SlotStatus slots={slots} free={isFree(s.id)} />
          </li>
        ))}
      </ul>
      <Link to="/book" className="btn-ghost-riot mt-8 w-full" data-testid="hero-next-day-book-btn">Grab a slot</Link>
    </div>
  );
};
